import React from "react";
import { Card } from "@/CommonElements/Hajj/Card";
import { Stack } from "react-bootstrap";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  HajiIcon,
  PassportIcon,
  EarthFreeIcons,
  UserIdVerificationIcon,
  Location05Icon,
  MapsGlobal01Icon,
  GridIcon,
  RotateClockwiseIcon,
  UserGroup03Icon,
} from "@hugeicons/core-free-icons";
import { getAvatarLetters, toArabicNumerals } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import { useLocalizedText } from "@utils/hooks/useLocalizedText";
import { SelectCountry } from "@Component/Form/SelectCountry/SelectCountry";
import { STACK_4 } from "./PilgrimDetails";
import { LabelValue } from "@Component/Value";
import { AntSekelton } from "@Component/Skeleton/Skeleton";

export const PilgrimOverView = (props) => {
  const { t } = useTranslation();
  const { getLocalizedText } = useLocalizedText();
  const { isLoading } = props;

  const displayImageUrl = null;

  const {
    full_name_ar,
    full_name_en,
    pilgrim_number,
    passport_number,
    nationality_id,
    gender,
    id_number,
    age,
    age_category,
    pilgrim_type,
  } = props;
  const name = getLocalizedText(full_name_ar, full_name_en);

  const HorizontalVerticalLabelValue = (props) => (
    <LabelValue loading={isLoading} {...props} />
  );

  const skeletonHeader = (
    <Stack direction="horizontal" gap={2}>
      <AntSekelton.Avatar size="large" />
      <Stack className="align-self-center" gap={1}>
        <AntSekelton.Text />
        <AntSekelton.Text />
      </Stack>
    </Stack>
  );

  const header = (
    <Stack direction="horizontal" gap={2} className="flex-wrap">
      <div className="avatar avatar-lg">
        {displayImageUrl ? (
          <img className="border-3 border" src={displayImageUrl} alt="" />
        ) : (
          <span>{getAvatarLetters(name).split("")}</span>
        )}
      </div>
      <Stack className="align-self-center" gap={1}>
        <p className="H5 mb-0">{name}</p>
      </Stack>
    </Stack>
  );

  return (
    <Card header={isLoading ? skeletonHeader : header}>
      <STACK_4>
        <HorizontalVerticalLabelValue
          copyValue={pilgrim_number}
          icon={<HugeiconsIcon icon={HajiIcon} />}
          label={t("PILGRIM_NUMBER")}
          value={pilgrim_number}
        />
        <HorizontalVerticalLabelValue
          copyValue={passport_number}
          icon={<HugeiconsIcon icon={PassportIcon} />}
          label={t("PASSPORT_NUMBER_LABEL")}
          value={passport_number}
        />
        <HorizontalVerticalLabelValue
          icon={<HugeiconsIcon icon={EarthFreeIcons} />}
          label={t("NATIONALITY_LABEL")}
          renderValue={() => <SelectCountry.Display value={nationality_id} />}
        />
        <HorizontalVerticalLabelValue
          icon={<HugeiconsIcon icon={UserIdVerificationIcon} />}
          label={t("GENDER_LABEL")}
          value={t(gender?.toUpperCase() ?? "")}
        />
        <HorizontalVerticalLabelValue
          copyValue={id_number}
          icon={<HugeiconsIcon icon={GridIcon} />}
          label={t("ID_NUMBER_LABEL")}
          value={id_number}
        />
        <HorizontalVerticalLabelValue
          icon={<HugeiconsIcon icon={RotateClockwiseIcon} />}
          label={t("AGE_LABEL")}
          value={age}
        />
        <HorizontalVerticalLabelValue
          icon={<HugeiconsIcon icon={UserGroup03Icon} />}
          label={t("AGE_CATEGORY_LABEL")}
          value={age_category}
        />
        <HorizontalVerticalLabelValue
          icon={<HugeiconsIcon icon={HajiIcon} />}
          label={t("PILGRIM_TYPE")}
          value={pilgrim_type}
        />
      </STACK_4>
    </Card>
  );
};
